let identifierkey = 0
export function getIdentifierKey() {
  identifierkey++
  return identifierkey
}
